<!-- PATIENT SCREENING Info component -->
<template>
  <md-card id="screening" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-green">
      <div class="card-icon">
        <md-icon>assignment_ind</md-icon>
      </div>
      <h3 class="title" style="font-weight: 400; margin-bottom: 20px;">
        {{ patientInfo.firstName }} {{ patientInfo.lastName }}
      </h3>
      <h5 class="title" style="margin-bottom: 20px;">{{ getOrgBusiness }}</h5>
    </md-card-header>

    <hr />

    <md-card-content>
      <div class="md-layout ">
        <!--<div class="md-layout-item md-size-5"></div>-->

        <!--PATIENT INFO-->
        <div class="md-layout-item md-size-60">
          <md-card class="md-with-hover" >
            <span style="margin-left: 15px; margin-top: 12px; font-size: .85rem; font-weight: 400; color: green"
              >Patient Information</span
            >
            <md-card-content style="height: 237px;">
              <div class="md-layout md-gutter">
                <label class="md-layout-item  md-size-15 md-form-label">Email</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2" v-html="getEmail" />
                </div>

                <label class="md-layout-item md-size-15 md-form-label">Phone</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getPhone }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-15 md-form-label" style="margin-left: 15px;">DOB (Age)</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getDob }} &nbsp; &nbsp;[&nbsp;{{ getAge }}&nbsp;] </md-field>
                </div>

                <label class="md-layout-item md-size-15 md-form-label">Gender</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2" style="text-transform: capitalize;">{{ patientInfo.gender }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-15 md-form-label">Eyewear</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ patientInfo.wearsCorrectiveLens }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-15 md-form-label">Address</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getAddress }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-15 md-form-label" style="margin-left: 15px;">City/St/Zip</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getCityStZip }}</md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>

        <!--SCREENING INFO-->
        <div class="md-layout-item md-size-40" >
          <md-card class="md-with-hover">
            <span style="margin-left: 15px;  margin-top: 12px; font-size: .85rem; font-weight: 400; color: green"
              >Screening Information</span
            >
            <md-card-content>
              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-20 md-form-label">Date</label>
                <div class="md-layout-item" style="padding-left:5px; font-weight: 700;">
                  <md-field class="field2">{{ getScreenDate }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-20 md-form-label">Start</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getScreenStart }}</md-field>
                </div>

                <label class="md-layout-item md-size-20 md-form-label">End</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getScreenEnd }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-20 md-form-label">Duration</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getDuration }}</md-field>
                </div>
                <label class="md-layout-item md-size-20 md-form-label">GlobeID</label>
                <div class="md-layout-item" style="padding-left:0px;">
                  <md-field class="field2">{{ screeningInfo.globeId }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">Location</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ screeningInfo.globeLocation }}</md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">Technician</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ screeningInfo.technician }}</md-field>
                </div>
              </div>
              <!-- <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-33 md-form-label"
                >Screening Type</label
                > -->
              <!-- style="text-align: center" -->
              <!--
              <div class="md-layout-item" style="padding-left:5px;">
                <md-field class="field2">
                  {{ getScreenType }}
                </md-field>
              </div>
            </div> -->
            </md-card-content>
          </md-card>
        </div>

        <!--<div class="md-layout-item md-size-5"></div>-->
      </div>

      <!--Insured INFO-->
      <screening-insurer-info />

      <!--HISTORY INFO-->
      <hr style="margin: 0px 15px" />
      <screening-history-info style="margin-left: 15px; margin-right: 15px;" />

      <!--ASSETS INFO
      <hr style="width: 95%; " />
      <screening-assets-info></screening-assets-info>-->
    </md-card-content>
  </md-card>
</template>

<script>
import moment from "moment"
//import InfoScreeningAssets from '@/components/GlobeChek/screening/info-screening-assets'
import InfoScreeningHistory from "@/components/GlobeChek/screening/info-screening-history"
import InfoPatientInsurer from "./info-screening-insurer.vue"
import { mapGetters } from "vuex"
export default {
  name: "InfoPatientScreening",
  components: {
    //'screening-assets-info': InfoScreeningAssets,
    "screening-history-info": InfoScreeningHistory,
    "screening-insurer-info": InfoPatientInsurer
  },

  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(["patientInfo", "screeningInfo"]),
    getDob() {
      return moment(this.patientInfo.dob, "YYYY-MM-DD").format("l")
    },
    getAge() {
      return moment().diff(this.patientInfo.dob, "years", false)
    },
    getEmail() {
      var eml = this.patientInfo.email
      return '<a href="mailto:' + eml + '">' + eml + "</a>"
    },
    getPhone() {
      var phn = this.patientInfo.phone == null ? "-" : this.patientInfo.phone
      return phn
    },
    getAddress() {
      var addr = this.patientInfo.address
      var ln1 = addr.addressLn1 == null ? "-" : addr.addressLn1
      var ln2 = addr.addressLn2 == null ? " " : addr.addressLn2
      var addrPartA = ln1 + " " + ln2
      return addrPartA
    },
    getCityStZip() {
      var addr = this.patientInfo.address
      var city = addr.city == null ? "-" : addr.city + ","
      var state = addr.state == null ? " " : addr.state + " -"
      var zip = addr.zip == null ? " " : addr.zip
      var addrPartB = city + " " + state + " " + zip
      return addrPartB
    },
    getScreenDate() {
      if (!this.screeningInfo.screeningDate) {
        return "-"
      }
      return moment(this.screeningInfo.screeningDate).format("dddd MMMM Do, YYYY") // "MM/DD/YYYY"
    },
    getScreenStart() {
      if (!this.screeningInfo.screeningStart) {
        return "-"
      }
      return moment(this.screeningInfo.screeningStart).format("LT")
    },
    getScreenEnd() {
      if (!this.screeningInfo.screeningEnd) {
        return "-"
      }
      return moment(this.screeningInfo.screeningEnd).format("LT")
    },
    getDuration() {
      if (!this.screeningInfo.screeningDuration) {
        return "-"
      }
      if (this.screeningInfo.screeningDuration == "None") {
        return "-"
      }
      return this.screeningInfo.screeningDuration + " Min."
    },
    getScreenType() {
      return this.patientInfo.screenType === 0 ? "Test" : "Live"
    },
    getOrgBusiness() {
      return sessionStorage.getItem("OrgBusiness")
    },
    getOrgCode() {
      return sessionStorage.getItem("OrgCode")
    }
  },
  methods: {
    mouseOver: function() {},
    mouseLeave: function() {}
  }
}
</script>

<style lang="scss" scoped>
#screening {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.label {
  font-size: 0.75rem;
  font-weight: 500;
}

.field {
  font-size: 0.95rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
}

.field2 {
  font-size: 0.85rem;
  font-weight: 400;
  color: rgb(0, 0, 139);
  padding-left: 7px;
  padding-bottom: 7px;
  margin-top: 5px;
}

.md-card .md-card-content .md-form-label {
  color: rgb(124, 124, 124);
  font-weight: 400;
  margin-bottom: 0;
  line-height: 1;
  padding-top: 10px;
}
</style>
